import { Show, Tab, TabbedShowLayout, TabbedShowLayoutTabs, useRecordContext, useRefresh } from "react-admin";
import { Button as MUIButton, Stack } from "@mui/material";
import { useLocation } from "react-router-dom";
import MultiDayChefitMetaShow from "./MultiDayChefitMetaShow";
import OmsListForMultiChefit from "../OneMealService/OmsListForMultiChefit";
import { MultiDayChefitStatus } from "../../enums/MultiDayChefitStatus";
import { useState } from "react";
import ShowMultiDayChefitRefundAmountDailog from "../Common/ShowMultiDayChefitRefundAmountDailog";
import TrialsCancelDialog from "../Common/TrialsCancelDialog";
import AssignCookToMultiDayChefitDialog from "../Common/AssignCookToMultiDayChefitDialog";
import MultiDayChefitAvailabilityTable from "./MultiDayChefitAvailabilityTable";
import { MultiDayChefitService } from "../../services/MultiDayChefitService";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import ServiceNotificationsTab from "../Common/ServiceNotificationsTab";

const multiDayChefitService = new MultiDayChefitService();
interface InputProps {
  name: any;
  callback: (data: any) => void;
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
    | undefined;
}

const CustomButton = (props: InputProps) => {
  let record = useRecordContext();

  return (
    <MUIButton
      onClick={() => {
        props.callback(record);
      }}
      size={"small"}
      color={props.color || "secondary"}
      variant={"contained"}
      style={{ width: "max-content", fontSize: "12px" }}
    >
      {props.name}
    </MUIButton>
  );
};

export const ActionButtons = (props: any) => {
  const record = useRecordContext();
  const refresh = useRefresh();
  return (
    <div>
      <Stack direction={"row"} style={{ marginBottom: "10px", marginLeft:"10px" }} gap={2}>
       {/* {
            (record?.status !== (MultiDayChefitStatus.CANCELLED || MultiDayChefitStatus.PENDING)) && (
              <CustomButton
              name={"Calculate Refund Amount"}
              color="primary"
              callback={() => {
                EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                    message: "Are you sure you want to calculate refund amount?",
                    onClose: (confirmed: boolean) => {
                        if (confirmed) {
                            multiDayChefitService
                                .calculateRefundAmount(parseInt((record as any)?.id))
                                .then((res) => {
                                    props.setOpenRefundAmountTab(true);
                                    props.setRefundAmountObject(res);
                                });
                        }
                    },
                });
              }}
            />
            )
        } */}
        {/* {
          (record?.status !== MultiDayChefitStatus.PENDING && ![PaymentStatusEnum.REFUNDED, PaymentStatusEnum.REFUND_IN_PROGRESS].includes(record?.paymentStatus)) && (
            <CustomButton
            name={"Refund Multi Day"}
            color="error"
            callback={() => {
              EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                  message: "Are you sure you want to initiate refund ?",
                  onClose: (confirmed: boolean) => {
                      if (confirmed) {
                          multiDayChefitService
                              .refundMultiDayChefit(parseInt((record as any)?.id))
                              .then((res) => {
                                if (res) {
                                  EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                    message: "Success",
                                    type: CustomSnackbarTypes.SUCCESS,
                                  });
                                }
                        });
                      }
                  },
              });
            }}
          />
          )
        } */}
        {
            (![MultiDayChefitStatus.CANCELLED, MultiDayChefitStatus.PENDING].includes(record?.status)) && (
              <CustomButton
              name={"Cancel Multi Day Chefit"}
              color="error"
              callback={(data: any) => {
                props.setSelectedData(data);
                props.setCancelTrialModel(true);
                props.setInitiatedBy(2);
              }}
            />
            )
        }
        {
            (record?.status !== MultiDayChefitStatus.CANCELLED) && (
              <CustomButton
              name={"Assign Cook"}
              color="primary"
              callback={() => {
                props.setAssignCook(true);
              }}
            />
            )
        }
        {
            (record?.status !== MultiDayChefitStatus.CANCELLED) && (
              <CustomButton
              name={"Auto Allocate"}
              color="primary"
              callback={() => {
                EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                  message: "Available cook will be auto allocated. Do you want to proceed?",
                  onClose: (confirmed: boolean) => {
                    if (confirmed) {
                      multiDayChefitService
                        .autoAllocate(Number(record?.id))
                        .then(() => {
                          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                            message: "Auto allocation started",
                            type: CustomSnackbarTypes.SUCCESS,
                          });
                          refresh();
                        })
                        .catch((err: any) => {
                          EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                            message: err?.response?.data?.error || err?.response?.data?.message || "Failed to auto allocate",
                            type: CustomSnackbarTypes.ERROR,
                          });
                        });
                    }
                  },
                  title: "Confirmation",
                });
              }}
            />
            )
        }
      </Stack>
    </div>
  );
};

const MultiDayChefitTabs = () => {
  let location = useLocation();
  let multiDayChefitId = location.pathname.split("/")[2];
  let record = useRecordContext();
  return (
    <TabbedShowLayout tabs={<TabbedShowLayoutTabs variant="scrollable" scrollButtons="auto" selectionFollowsFocus={true} />}>
      <Tab label={"Details"} key={"Details"}>
        <MultiDayChefitMetaShow/>
      </Tab>
      <Tab label={"Chefit List"} key={"ChefitList"}>
        <OmsListForMultiChefit multiDayChefitId={parseInt(multiDayChefitId)}/>
      </Tab>
      <Tab label={"Cook Serve List"} key={"CookServeList"}>
        <MultiDayChefitAvailabilityTable dateTime = {record?.dateTime} totalPeople = {record?.totalPeople} areaId = {record?.areaId} houseId = {record?.houseId}/>
      </Tab>
      <Tab label={"Notifications"} key={"Notifications"}>
        <ServiceNotificationsTab referenceId={Number(multiDayChefitId)} referenceModelName="MULTI_DAY_CHEFIT" />
      </Tab>
    </TabbedShowLayout>
  );
};

const MultiDayChefitShow = (props: any) => {
    let location = useLocation();
    let multiDayChefitId = location.pathname.split("/")[2];

    let[openRefundAmountTab, setOpenRefundAmountTab] = useState<boolean>(false);
    let[refundAmountObject, setRefundAmountObject] = useState<any>(null);
    let [cancelTrialModel, setCancelTrialModel] = useState<boolean>(false);
    let [assignCook, setAssignCook] = useState<boolean>(false);
    let [selectedData, setSelectedData] = useState<any>(null);
    const [initiatedBy, setInitiatedBy] = useState<any>();
    
  return (
    <Show {...props} actions={false}>
      <div>
        {
            openRefundAmountTab &&
            <ShowMultiDayChefitRefundAmountDailog 
                openRefundAmountTab = {openRefundAmountTab}
                callback = {() => {
                    setOpenRefundAmountTab(false);
                }}
                refundAmountObject = {refundAmountObject}
            />
        }
        {cancelTrialModel && <TrialsCancelDialog
          intiatedBy={initiatedBy}
          data={selectedData}
          open={cancelTrialModel}
          callback={() => {
            setCancelTrialModel(false);
          }}
          isMultiChefit = {true}
        />}
        {
          assignCook && 
          <AssignCookToMultiDayChefitDialog
           open = {assignCook}
           callback={() => {
            setAssignCook(false);
          }}
           serviceId = {multiDayChefitId}
          />
        }
        <Show {...props} actions={false}>
          <ActionButtons
           setOpenRefundAmountTab = {setOpenRefundAmountTab}
           setRefundAmountObject = {setRefundAmountObject}
           setInitiatedBy={setInitiatedBy}
           setSelectedData={setSelectedData}
           setCancelTrialModel={setCancelTrialModel}
           setAssignCook = {setAssignCook}
          />
          <MultiDayChefitTabs />
        </Show>
      </div>
    </Show>
  );
};

export default MultiDayChefitShow;